import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogClose } from "@angular/material/dialog";
import { MatIconButton } from "@angular/material/button";
import { Score } from "../../../entities/tools/score/score";
import { Formula } from "../../../entities/formula/formula";
import { ScoreViewerComponent } from "../../tools/score/score-viewer/score-viewer.component";
import { FormulaViewerComponent } from "../../core/formula-viewer/formula-viewer.component";
import { MatIcon } from "@angular/material/icon";

export type ToolViewerType = "score" | "formula";

export interface ToolViewerModalData {
	type: ToolViewerType;
	item: Score | Formula;
}

@Component({
	selector: "app-tool-viewer-modal",
	templateUrl: "./tool-viewer-modal.component.html",
	styleUrl: "./tool-viewer-modal.component.scss",
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [
		MatDialogTitle,
		MatDialogContent,
		MatDialogClose,
		ScoreViewerComponent,
		FormulaViewerComponent,
		MatIcon,
		MatIconButton,
	],
})
export class ToolViewerModalComponent {
	data = inject<ToolViewerModalData>(MAT_DIALOG_DATA);

	get asScore(): Score {
		return this.data.item as Score;
	}

	get asFormula(): Formula {
		return this.data.item as Formula;
	}
}
